import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import './tabs.css'
import { fetchData } from '../../data'
import { getLocalPath } from '../../utility'
import { renderCard, renderList } from './DisplayStyles.jsx'

const halApi = async (type, scope) => {
  const response = await fetchData(
    `${getLocalPath()}/halapi/${type}?_limit=40&_scope=${scope}`
  )
  return response
}

const getFolderNames = (folders) => {
  // parent folder is included in api and has a path of ''
  const excludeSelf = (item) => item._meta.path !== ''
  return folders.filter(excludeSelf).map((folder) => {
    const { path, name, id } = folder._meta
    return { path, name, id }
  })
}

const groupArticlesByPath = (documents) => {
  const documentsByPath = {}
  documents.forEach((e) => {
    // get first folder in path
    //"2021/acquisition-of-bmos-emea-asset-management-business"
    const path = e._meta.path.split('/')[0]
    if (!documentsByPath[path]) {
      documentsByPath[path] = []
    }
    documentsByPath[path].push(e)
  })
  return documentsByPath
}

const getDisplayRenderer = (type) => {
  switch (type.toLowerCase()) {
    case 'cards':
      return renderCard
    default:
      return renderList
  }
}

const Tabs = ({ page, component }) => {
  const [folders, setFolders] = useState(undefined)
  const [articles, setArticles] = useState(undefined)
  const [selectedFolder, setSelectedFolder] = useState({
    year: new Date().getFullYear(),
  })
  let init = false
  const params = component.getParameters()
  const scope = params?.document
  const sortTabsDescending = params?.sortTabs === 'Descending'
  const sortContentDescending = params?.sortContent === 'Descending'
  const renderer = getDisplayRenderer(params?.displayStyle)
  const sortByProperty = (descending, property) => {
    return descending
      ? (a, b) => {
          return a[property] === b[property]
            ? 0
            : a[property] < b[property]
              ? -1
              : 1
        }
      : (a, b) => {
          return a[property] === b[property]
            ? 0
            : a[property] < b[property]
              ? 1
              : -1
        }
  }
  const tabSorter = sortByProperty(sortTabsDescending, 'path')
  const contentSorter = sortByProperty(sortContentDescending, 'publicationDate')

  useEffect(() => {
    if (!init) {
      init = true
      const getFolders = async (scope) => {
        const folders = await halApi('folders', scope)
        const sortedFolders = getFolderNames(folders._embedded.folders).sort(
          tabSorter
        )
        setFolders(sortedFolders)
      }

      if (scope) {
        getFolders(scope)
      }
    }
  }, [sortTabsDescending])

  useEffect(() => {
    if (!folders) return
    const getDocumentsInFolder = async (scope) => {
      const articles = await halApi('documents', scope)
      const grouped = groupArticlesByPath(articles._embedded.documents)
      Object.keys(grouped).forEach((year) => {
        grouped[year].sort(contentSorter)
      })
      setArticles(grouped)
    }
    getDocumentsInFolder(scope)
  }, [folders, sortContentDescending])

  useEffect(() => {
    if (articles) {
      const tabs = Object.keys(articles)
      const defaultSelected = sortTabsDescending
        ? tabs[0]
        : tabs[tabs.length - 1]
      setSelectedFolder({ year: defaultSelected })
    }
  }, [articles])

  const selectFolder = (folder) => {
    setSelectedFolder(folder)
  }

  return (
    <div className="">
      <div className="Tabs u-posRelative u-sizeConstrained u-paddingTop12gu u-paddingBottom8gu ">
        {folders && articles && (
          <ul className="u-flex u-marginBottom6gu u-borderBottom">
            {folders.map((value, index) => {
              const padding = index === 0 ? 'u-paddingLeft0' : ''
              const border =
                selectedFolder.year == value.path
                  ? 'u-borderBottom u-tabsActiveBorder border-width'
                  : ''

              const articleGroups = Object.keys(articles)
              if (!articleGroups.some((year) => year === value.path)) {
                return null
              }
              return (
                <li
                  key={value.id}
                  className={border}
                  onClick={() => {
                    selectFolder({ year: value.path })
                  }}
                >
                  <button
                    className={`Button u-textBold tab-button u-textCapitalize u-border0 ${padding}`}
                  >{`${value.name} Releases`}</button>
                </li>
              )
            })}
          </ul>
        )}

        {articles && (
          <div className="u-flex u-flexWrap u-flexJustifyBetween after-flex">
            {Object.keys(articles)
              .filter((key) => key == selectedFolder.year)
              .map((key) => {
                return articles[key].map(renderer(page).render)
              })}
          </div>
        )}
      </div>
    </div>
  )
}

Tabs.propTypes = {
  page: PropTypes.object,
  component: PropTypes.object,
}
export default Tabs
